<script lang="ts">
  import { locate } from '../state/here.svelte'
  import Icon from './Icon.svelte'

  /**
   * My location, as a 48 px square of ground on the float shadow over the
   * map (Phase 11 plan §5.2, §7), or as a square ink button in a panel bar
   * (`ink`). A failure is the button's title: the status line under the
   * place says why too. Placed by the layout.
   */

  let { ink = false }: { ink?: boolean } = $props()

  let locating = $state(false)
  let error = $state('')

  async function locateHere() {
    locating = true
    error = ''
    try {
      error = (await locate()) ?? ''
    } finally {
      locating = false
    }
  }
</script>

<button
  type="button"
  class="{ink ? 'wx-ink-btn' : 'wx-float-btn'} touch-target"
  aria-label="My location"
  title={error || 'My location'}
  disabled={locating}
  onclick={locateHere}
>
  <Icon name="locate-fixed" size={ink ? 18 : 22} />
</button>
